import { IApplicationState } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { createReduxStore } from '../../../shared/utils/redux';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true, context);
}
